import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import ActivityLoader from "../../components/Common/ActivityLoader";
import ajaxUser from "../../util/remote/ajaxUser";
import LeftAd from "../../components/Welcome/LeftAd";
import AlertVerifyEmail from "../../components/Welcome/AlertVerifyEmail";

const ForgotPasswordPage = () => {
  const isLoggedIn = localStorage.getItem("ofc");
  const [showAlert, setShowAlert] = useState(false);
  const [codeRequested, setCodeRequested] = useState(false);
  

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState("");
  const navigate = useNavigate();



  const onSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setInfo(<Notification message="Enter your email address" type="danger" />);
      return;
    }

    if (loading) return;

    // If verification already requested, just open the modal again
    if (codeRequested) {
      setShowAlert(true);
      return;
    }

    try {
      setLoading(true);
      const server_response = await ajaxUser.forgotPassword(email);

      if (server_response?.status === "OK") {
        setCodeRequested(true);
        setInfo(
          <Notification
            message={
              server_response?.message ||
              "We’ve sent password reset instructions to your email."
            }
            type="success"
            closable={false}
          />
        );
        setShowAlert(true);
      } else {
        setInfo(
          <Notification
            message={server_response?.message || "Failed to request reset. Try again."}
            type="danger"
            closable={false}
          />
        );
      }
    } catch (err) {
      setInfo(
        <Notification
          message="Something went wrong. Please try again."
          type="danger"
          closable={false}
        />
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVerify =async (code)=>{
    if (loading) return;
    setLoading(true);

    const data = {
      email_address: email,
      code: code
    }

    const server_response = await ajaxUser.verifyPasswordReset(data);

    if (server_response?.status === "OK") {
      setInfo(
        <Notification
          message={server_response?.message || "Email verified. You can now reset your password."}
          type="success"
          closable={false}
        />
      );
       setShowAlert(false);
      localStorage.setItem("ofc", server_response.details.token);
       navigate("/password-reset", { replace: true });
       window.location.reload();
    } else {
      setInfo(
        <Notification
          message={server_response?.message || "Verification failed. Try again."}
          type="danger"
          closable={false}
        />
      );
    }
    setLoading(false);
  }

 if (isLoggedIn) return <Navigate to="/dashboard" />;

  return (
    <>
    <div className="ofLoginRoot">
      <div className="ofLoginBg" />

      <div className="ofLoginWrap">
        <div className="ofLoginGrid">
          {/* LEFT: Benefits */}
          <LeftAd />

          {/* RIGHT: Form */}
          <div className="ofLoginRight">
            <div className="ofLoginCard">
              <div className="ofLoginHeader">
                <div className="ofLoginTitle">Forgot password</div>
                <div className="ofLoginSub">
                  Enter your email and we’ll send reset instructions.
                </div>
              </div>

              {info}
              {loading && <ActivityLoader />}

              <form onSubmit={onSubmit} className="ofForm">
                <div className="ofField">
                  <label htmlFor="email">Email address</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                  />
                </div>

                <button className="ofBtn" type="submit" disabled={loading}>
                  {loading ? "Please wait..." : "Request Password Reset"}
                </button>

                <div className="ofFooter" style={{ marginTop: 14 }}>
                  <span>Remembered your password?</span>{" "}
                  <Link to="/login" className="ofLinkStrong">
                    Sign in
                  </Link>
                </div>

                <div className="ofFooter" style={{ marginTop: 8 }}>
                  <span>Need a new account?</span>{" "}
                  <Link to="/signup" className="ofLinkStrong">
                    Create one
                  </Link>
                </div>
              </form>
            </div>

            <div className="ofLegal">
              If you don’t see the email, check spam/junk and confirm the address is correct.
            </div>
          </div>
        </div>
      </div>
    </div>

    <AlertVerifyEmail
        show={showAlert}
        email={email}
        onClose={() => setShowAlert(false)}
        onConfirm={(code) => handleVerify(code)}
      />
    </>
  );
};

export default ForgotPasswordPage;
